<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-col mt-4">
    <label for="comment" class="soft-label soft-label-top">{{
      '#TICKETS.DIALOGS.ADD_COMMENT.COMMENT' | translate
    }}</label>
    <soft-multiline-input
      formControlName="comment"
      id="comment"
      #multilineInput
    ></soft-multiline-input>
  </div>
  @if (isEditor()) {
    <div class="mt-4 flex items-center gap-1">
      <soft-checkbox formControlName="internal"> </soft-checkbox>
      <span class="text-sm">{{
        '#TICKETS.DIALOGS.ADD_COMMENT.INTERNAL' | translate
      }}</span>
    </div>
  }
  <div class="flex flex-row justify-end mt-4">
    <button
      type="submit"
      [disabled]="form.invalid"
      class="soft-button soft-button-primary rounded hover:cursor-pointer"
    >
      {{ '#TICKETS.DIALOGS.ADD_COMMENT.SUBMIT' | translate }}
    </button>
  </div>
</form>
<!--<div style="white-space: pre-line">{{multilineInput.value}}</div>-->
